// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3jfg6","colMin":"styles_colMin__2BlBI","colCheckbox":"styles_colCheckbox__3Onxm"};